module.exports = __webpack_public_path__ + "static/media/absolute_power_white.5d66e269.svg";